import React, { useState } from "react";

import styled from "styled-components/macro";

import API from "Signups/API";
import { useIsSignupClosed } from "Signups/SharedComponents/useIsSignupClosed";
import { useSignups } from "Signups/state";

import FnrCheckbox from "UI/FnrEnrichedCheckbox/FnrCheckbox";

import { fundItStateHooks } from "./stateHooks";

export default function SuggestedDonationCheckbox() {
  const [
    {
      currentSignupList: { ID, fundIt },
    },
    dispatch,
  ] = useSignups();
  const { isSuggestedDonation, fund } = fundIt;
  const amounts = fundIt?.cost?.amounts;

  const commonPostData = fundItStateHooks.useCommonFundItPostData();

  const { isArchived } = useIsSignupClosed();

  const signupPaymentsCollected = fund?.signupPaymentsCollected;

  const [isSaving, setIsSaving] = useState(false);

  function dispatchStateUpdates(value) {
    dispatch({
      type: "setIsSuggestedDonation",
      payload: value,
    });
    dispatch({
      type: "updateAllSignupListItems",
      key: "isSuggestedDonation",
      value: value,
    });
  }

  function toggleCheckbox() {
    if (signupPaymentsCollected || isSaving) return;

    const origValue = isSuggestedDonation;
    const newValue = !isSuggestedDonation;

    const postData = {
      ...commonPostData,
      signupListID: ID,
      isSuggestedDonation: newValue,
      amounts,
    };

    // Optimistically update
    dispatchStateUpdates(newValue);

    setIsSaving(true);
    API.editFundItOptions(ID, postData)
      .post()
      .then(() => {
        // Do nothing. State was already optimistically updated.
      })
      .catch((err) => {
        // revert optimistic updates
        dispatchStateUpdates(origValue);
        alert(
          "Oh no! Something went wrong- please refresh and try again, or contact help@flocknote.com."
        );
      })
      .finally(() => {
        setIsSaving(false);
      });
  }

  // Don't show UI if the setting is off and can't be turned on
  if (!isSuggestedDonation && signupPaymentsCollected) return null;

  return (
    <Wrapper>
      <FnrCheckbox
        on={Boolean(isSuggestedDonation)}
        toggleOn={toggleCheckbox}
        style={{ fontWeight: 300 }}
        disabled={signupPaymentsCollected || isArchived}
      >
        Collect as suggested donation
      </FnrCheckbox>
      <HelpText>
        Checking this box sets the payment as a suggested donation. This will
        allow the member to edit and adjust the amount of money they donate.
      </HelpText>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin-top: 24px;
`;
const HelpText = styled.div`
  font-size: 15px;
  color: #828c8d;
  padding-left: 34px;
  box-sizing: border-box;
  font-weight: 400;
  max-width: 600px;
`;
